// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2HfNM","title":"ClientCherryInfo_title__3PEPN","itemText":"ClientCherryInfo_itemText__3pg1Z"};